(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-editorial-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ns-editorial-home')) {
  customElements.define('ns-editorial-home', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.logoObserver?.disconnect();
      this.controller = new AbortController();

      const signal = this.controller.signal;
      const options = { signal };
      const drawer = this.querySelector('.ns-home-drawer');
      const openButton = this.querySelector('[data-ns-open]');
      const closeButton = this.querySelector('[data-ns-close]');
      const mobile = window.matchMedia('(max-width: 749px)');
      const logo = this.querySelector('.ns-home-logo');
      const count = this.querySelector('[data-ns-cart-count]');
      let requestNumber = 0;

      const refreshCount = async () => {
        if (!count || signal.aborted) return;

        const currentRequest = ++requestNumber;

        try {
          const response = await fetch(this.dataset.nsCartUrl, {
            credentials: 'same-origin',
            cache: 'no-store',
            signal
          });

          if (!response.ok) return;

          const cart = await response.json();

          if (signal.aborted || currentRequest !== requestNumber) return;

          const quantity = Number(cart.item_count);

          if (!Number.isFinite(quantity) || quantity < 0) return;

          count.textContent = quantity > 99 ? '99+' : String(quantity);
        } catch (error) {
          if (error.name !== 'AbortError') {
            console.warn('Unable to refresh bag quantity.', error);
          }
        }
      };

      if (logo) {
        this.logoObserver = new ResizeObserver(() => {
          const bottom = logo.getBoundingClientRect().bottom;

          this.style.setProperty(
            '--ns-menu-top',
            (bottom + 24) + 'px'
          );
        });

        this.logoObserver.observe(logo);
      }

      openButton?.addEventListener('click', () => {
        if (mobile.matches && drawer && !drawer.open) {
          drawer.showModal();
          openButton.setAttribute('aria-expanded', 'true');
        }
      }, options);

      closeButton?.addEventListener('click', () => {
        drawer?.close();
      }, options);

      drawer?.addEventListener('close', () => {
        openButton?.setAttribute('aria-expanded', 'false');

        if (mobile.matches && openButton?.isConnected) {
          openButton.focus();
        }
      }, options);

      drawer?.addEventListener('click', (event) => {
        if (event.target !== drawer) return;

        const box = drawer.getBoundingClientRect();

        if (
          event.clientX < box.left ||
          event.clientX > box.right ||
          event.clientY < box.top ||
          event.clientY > box.bottom
        ) {
          drawer.close();
        }
      }, options);

      mobile.addEventListener('change', () => {
        if (!mobile.matches && drawer?.open) drawer.close();
      }, options);

      this.querySelector('[data-ns-dismiss]')
        ?.addEventListener('click', () => {
          this.querySelector('.ns-home-announcement').hidden = true;
        }, options);

      window.addEventListener('pageshow', (event) => {
        if (event.persisted) refreshCount();
      }, options);

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') refreshCount();
      }, options);

      import('@shopify/events').then(({ StandardEvents }) => {
        if (signal.aborted) return;

        document.addEventListener(
          StandardEvents.cartLinesUpdate,
          async (event) => {
            try {
              await event.promise;
            } catch {}

            if (!signal.aborted) refreshCount();
          },
          options
        );

        refreshCount();
      }).catch((error) => {
        if (!signal.aborted) {
          console.warn('Unable to connect bag updates.', error);
          refreshCount();
        }
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.logoObserver?.disconnect();

      const drawer = this.querySelector('.ns-home-drawer');

      if (drawer?.open) drawer.close();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-quick-add-drawer"]) return;
  try {
    
if (!customElements.get('ns-quick-add-enhancer')) {
  customElements.define('ns-quick-add-enhancer', class extends HTMLElement {
    static active;

    connectedCallback() {
      this.constructor.active?.stop();
      this.constructor.active = this;
      this.config = JSON.parse(this.querySelector('script').textContent);
      if (!this.config.enabled) return;
      this.controller = new AbortController();
      this.chartRequests = new Set();
      this.chartCache = new Map();
      this.inertStates = new Map();
      this.labelStates = new Map();
      this.frame = 0;
      this.opening = false;
      document.documentElement.classList.add('ns-qa-enabled');
      const variables = {
        '--ns-qa-width': `${this.config.width}px`,
        '--ns-qa-dim': this.config.dim / 100,
        '--ns-qa-blur': `${this.config.blur}px`,
        '--ns-qa-mobile-height': `${this.config.mobileHeight}dvh`,
        '--ns-qa-media-height': `${this.config.mediaHeight}dvh`,
        '--ns-qa-title-size': `${this.config.titleSize}px`,
        '--ns-qa-text-size': `${this.config.textSize}px`,
        '--ns-qa-button-height': `${this.config.buttonHeight}px`,
        '--ns-qa-mobile-radius': `${this.config.radius}px`
      };
      this.variableNames = Object.keys(variables);
      for (const [name, value] of Object.entries(variables)) {
        document.documentElement.style.setProperty(name, value);
      }
      const currentChart = this.parseChart(document);
      if (currentChart && location.pathname.includes('/products/')) {
        this.chartCache.set(location.pathname, currentChart);
      }
      const signal = this.controller.signal;
      document.addEventListener('click', event => this.handleCardClick(event), {capture: true, signal});
      document.addEventListener('theme-drawer:open', () => this.schedule(), {capture: true, signal});
      document.addEventListener('theme-drawer:close', () => this.schedule(), {capture: true, signal});
      document.addEventListener('dialog:open', () => this.schedule(), {capture: true, signal});
      document.addEventListener('dialog:close', () => this.schedule(), {capture: true, signal});
      this.observer = new MutationObserver(records => {
        if (records.some(record => this.isRelevant(record))) this.schedule();
      });
      this.observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['open', 'hidden', 'href', 'view-event-payload']
      });
      this.schedule();
    }

    disconnectedCallback() {
      if (this.constructor.active === this) this.stop();
    }

    stop() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame || 0);
      this.chartRequests?.forEach(controller => controller.abort());
      this.inertStates?.forEach((value, element) => { element.inert = value; });
      this.labelStates?.forEach((value, element) => {
        if (value === null) element.removeAttribute('aria-label');
        else element.setAttribute('aria-label', value);
      });
      document.documentElement.classList.remove('ns-qa-enabled');
      this.variableNames?.forEach(name => document.documentElement.style.removeProperty(name));
      const host = document.getElementById('quick-add-dialog');
      host?.querySelectorAll('.ns-qa-heading, .ns-qa-slider, .ns-qa-size').forEach(node => node.remove());
      host?.querySelectorAll('.ns-qa-media-ready').forEach(node => node.classList.remove('ns-qa-media-ready'));
      const dialog = host?.querySelector('dialog');
      dialog?.classList.remove('ns-qa-drawer');
      if (dialog?.getAttribute('aria-labelledby') === 'NsQaTitle') dialog.removeAttribute('aria-labelledby');
    }

    isRelevant(record) {
      const element = record.target instanceof Element ? record.target : record.target.parentElement;
      if (element?.closest('#quick-add-dialog, #cart-drawer, product-card')) return true;
      return Array.from(record.addedNodes).some(node => node instanceof Element &&
        (node.matches('#quick-add-dialog, #cart-drawer, ns-sticky-purchase, sticky-add-to-cart, product-card') ||
         node.querySelector('#quick-add-dialog, #cart-drawer, ns-sticky-purchase, sticky-add-to-cart, product-card')));
    }

    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.enhance();
        this.syncLayers();
      });
    }

    async handleCardClick(event) {
      const button = event.target instanceof Element ? event.target.closest('#MainContent product-card .card-gallery button.quick-add__button') : null;
      if (!button || button.disabled || button.closest('.ns-cart-cross-sell')) return;
      if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const quickAdd = button.closest('quick-add-component');
      if (typeof quickAdd?.handleClick !== 'function') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.opening) return;
      this.opening = true;
      button.setAttribute('aria-busy', 'true');
      try {
        const cart = document.getElementById('cart-drawer');
        if (cart?.hasAttribute('open') && typeof cart.close === 'function') await cart.close();
        await quickAdd.handleClick(event);
        this.enhance();
        this.schedule();
      } catch {
        const href = quickAdd.productPageUrl;
        if (href) location.assign(href);
      } finally {
        this.opening = false;
        button.removeAttribute('aria-busy');
      }
    }

    syncLayers() {
      const cart = document.getElementById('cart-drawer');
      const cartOpen = Boolean(cart?.hasAttribute('open') || cart?.querySelector('dialog[open]'));
      const host = document.getElementById('quick-add-dialog');
      const dialog = host?.querySelector('dialog');
      const quickOpen = Boolean(dialog?.open);
      if (cartOpen && quickOpen && !dialog.classList.contains('dialog-closing') && typeof host.closeDialog === 'function') {
        host.closeDialog();
      }
      for (const sticky of document.querySelectorAll('ns-sticky-purchase, sticky-add-to-cart')) {
        if (!this.inertStates.has(sticky)) this.inertStates.set(sticky, Boolean(sticky.inert));
        const value = cartOpen || quickOpen || this.inertStates.get(sticky);
        if (sticky.inert !== value) sticky.inert = value;
      }
    }

    productInfo(root) {
      const anchor = root.querySelector('.view-product-title a, .product-header > a');
      if (!anchor?.getAttribute('href')) return null;
      const url = new URL(anchor.getAttribute('href'), location.href);
      if (url.origin !== location.origin || !url.pathname.includes('/products/')) return null;
      return {title: anchor.textContent.trim(), href: url.href, key: url.pathname};
    }

    enhance() {
      for (const button of document.querySelectorAll('#MainContent product-card .card-gallery button.quick-add__button')) {
        if (button.closest('.ns-cart-cross-sell')) continue;
        if (!this.labelStates.has(button)) this.labelStates.set(button, button.getAttribute('aria-label'));
        const title = button.closest('quick-add-component')?.dataset.productTitle || button.textContent.trim();
        const label = `${this.config.quickLabel}: ${title}`;
        if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      }
      this.labelStates.forEach((_, button) => { if (!button.isConnected) this.labelStates.delete(button); });
      const host = document.getElementById('quick-add-dialog');
      const dialog = host?.querySelector('dialog');
      const root = host?.querySelector('#quick-add-modal-content');
      if (!dialog || !root) return;
      dialog.classList.add('ns-qa-drawer');
      const info = this.productInfo(root);
      if (!info) return;
      let heading = dialog.querySelector('.ns-qa-heading');
      if (!heading) {
        heading = document.createElement('header');
        heading.className = 'ns-qa-heading';
        const title = document.createElement('h2');
        title.id = 'NsQaTitle';
        title.className = 'ns-qa-title';
        heading.append(title);
        dialog.insertBefore(heading, root);
      }
      const title = heading.querySelector('h2');
      if (title.textContent !== info.title) title.textContent = info.title;
      if (dialog.getAttribute('aria-labelledby') !== title.id) dialog.setAttribute('aria-labelledby', title.id);
      this.enhanceGallery(root);
      this.enhanceGuide(root, info);
    }

    enhanceGallery(root) {
      const media = root.querySelector('.product-information__media');
      const gallery = media?.querySelector('media-gallery');
      if (!media || !gallery) return;
      const grid = gallery.querySelector('.media-gallery__grid');
      const candidates = Array.from((grid || gallery.querySelector('slideshow-slides') || gallery).querySelectorAll('img'));
      const seen = new Set();
      const images = candidates.filter(image => {
        if (image.closest('[hidden]') || !image.getAttribute('src')) return false;
        const source = new URL(image.getAttribute('src'), location.href);
        const key = source.origin + source.pathname;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
      if (!images.length) return;
      const signature = images.map(image => image.getAttribute('src')).join('|');
      let slider = media.querySelector('.ns-qa-slider');
      if (slider?.dataset.signature === signature) return;
      slider?.remove();
      slider = document.createElement('section');
      slider.className = 'ns-qa-slider';
      slider.dataset.signature = signature;
      slider.setAttribute('aria-label', this.config.galleryLabel);
      const track = document.createElement('div');
      track.className = 'ns-qa-track';
      track.tabIndex = 0;
      const pagination = document.createElement('nav');
      pagination.className = 'ns-qa-pagination';
      pagination.setAttribute('aria-label', this.config.galleryLabel);
      pagination.hidden = images.length < 2;
      images.forEach((source, index) => {
        const slide = document.createElement('div');
        slide.className = 'ns-qa-slide';
        const image = source.cloneNode(true);
        image.removeAttribute('id');
        image.removeAttribute('style');
        image.className = 'ns-qa-image';
        image.sizes = `(min-width: 750px) ${this.config.width}px, 100vw`;
        image.setAttribute('loading', index ? 'lazy' : 'eager');
        image.setAttribute('decoding', 'async');
        slide.append(image);
        track.append(slide);
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ns-qa-dot';
        dot.setAttribute('aria-label', `${this.config.imageLabel} ${index + 1} / ${images.length}`);
        dot.setAttribute('aria-pressed', String(index === 0));
        dot.addEventListener('click', () => {
          track.scrollTo({left: index * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        });
        pagination.append(dot);
      });
      let lastIndex = -1;
      let scrollFrame = 0;
      const update = () => {
        scrollFrame = 0;
        const index = track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
        if (index === lastIndex) return;
        lastIndex = index;
        Array.from(track.children).forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== index)));
        Array.from(pagination.children).forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      };
      track.addEventListener('scroll', () => {
        if (!scrollFrame) scrollFrame = requestAnimationFrame(update);
      }, {passive: true});
      slider.append(track, pagination);
      media.prepend(slider);
      media.classList.add('ns-qa-media-ready');
      update();
    }

    enhanceGuide(root, info) {
      const form = root.querySelector('product-form-component');
      if (!form) return;
      const existing = root.querySelector('.ns-qa-size');
      if (existing?.dataset.productKey === info.key) return;
      existing?.remove();
      const guide = document.createElement('details');
      guide.className = 'ns-qa-size';
      guide.dataset.productKey = info.key;
      const summary = document.createElement('summary');
      summary.textContent = this.config.sizeGuide;
      const panel = document.createElement('div');
      panel.className = 'ns-qa-size-panel';
      guide.append(summary, panel);
      const target = form.closest('.buy-buttons-block') || form;
      target.before(guide);
      guide.addEventListener('toggle', () => {
        if (guide.open && !guide.dataset.loaded) this.loadGuide(guide, panel, info);
      });
    }

    async loadGuide(guide, panel, info) {
      if (guide.dataset.loading) return;
      guide.dataset.loading = 'true';
      panel.textContent = this.config.loadingLabel;
      panel.setAttribute('aria-busy', 'true');
      const controller = new AbortController();
      this.chartRequests.add(controller);
      try {
        let data = this.chartCache.get(info.key);
        if (!data) {
          const response = await fetch(info.key, {signal: controller.signal, credentials: 'same-origin'});
          if (!response.ok) throw new Error('Size guide request failed');
          const source = new DOMParser().parseFromString(await response.text(), 'text/html');
          data = this.parseChart(source);
          if (data) {
            if (this.chartCache.size >= 12) this.chartCache.delete(this.chartCache.keys().next().value);
            this.chartCache.set(info.key, data);
          }
        }
        if (!guide.isConnected || guide.dataset.productKey !== info.key) return;
        if (data) {
          this.renderChart(panel, data);
          guide.dataset.loaded = 'true';
        } else {
          this.guideMessage(panel, this.config.unavailableLabel, info);
        }
      } catch (error) {
        if (error.name !== 'AbortError' && guide.isConnected) this.guideMessage(panel, this.config.errorLabel, info);
      } finally {
        this.chartRequests.delete(controller);
        delete guide.dataset.loading;
        panel.removeAttribute('aria-busy');
      }
    }

    guideMessage(panel, text, info) {
      const message = document.createElement('p');
      message.textContent = text;
      const link = document.createElement('a');
      link.textContent = this.config.viewLabel;
      link.href = info.href;
      panel.replaceChildren(message, link);
    }

    parseChart(source) {
      const table = source.querySelector('#ns-size-guide-content table, table#size-guide');
      const rows = table ? Array.from(table.rows) : [];
      if (rows.length < 2) return null;
      const text = cell => cell?.textContent.replace(/\s+/g, ' ').trim() || '';
      const paired = rows.length > 2 && Array.from(rows[0].cells).some(cell => cell.colSpan === 2) &&
        Array.from(rows[1].cells).slice(1).every(cell => /^(inch(?:es)?|in|cm|centimet(?:er|re)s?)$/i.test(text(cell)));
      const sizes = [];
      let column = 1;
      const columns = [];
      for (const cell of Array.from(rows[0].cells).slice(1)) {
        const size = text(cell);
        if (size) {
          sizes.push(size);
          columns.push(column);
        }
        column += paired ? cell.colSpan : 1;
      }
      if (!sizes.length || sizes.length > 20) return null;
      const measures = rows.slice(paired ? 2 : 1).map(row => {
        const values = {inch: [], cm: [], raw: []};
        columns.forEach(index => {
          if (paired) {
            for (let offset = 0; offset < 2; offset++) {
              const unit = /cm|centimet/i.test(text(rows[1].cells[index + offset])) ? 'cm' : 'inch';
              values[unit].push(text(row.cells[index + offset]) || '—');
            }
          } else values.raw.push(text(row.cells[index]) || '—');
        });
        return {label: text(row.cells[0]), values};
      }).filter(row => row.label);
      return measures.length ? {sizes, measures, paired} : null;
    }

    renderChart(panel, data) {
      panel.replaceChildren();
      let unit = data.paired ? 'inch' : 'raw';
      const tabs = document.createElement('div');
      tabs.className = 'ns-qa-units';
      const wrap = document.createElement('div');
      wrap.className = 'ns-qa-table-wrap';
      const paint = () => {
        const table = document.createElement('table');
        const head = table.createTHead().insertRow();
        [this.config.sizeLabel, ...data.sizes].forEach(label => {
          const cell = document.createElement('th');
          cell.scope = 'col';
          cell.textContent = label;
          head.append(cell);
        });
        const body = table.createTBody();
        for (const measure of data.measures) {
          const row = body.insertRow();
          const title = document.createElement('th');
          title.scope = 'row';
          title.textContent = measure.label;
          row.append(title);
          measure.values[unit].forEach(value => { row.insertCell().textContent = value; });
        }
        wrap.replaceChildren(table);
        for (const button of tabs.children) button.setAttribute('aria-pressed', String(button.dataset.unit === unit));
      };
      if (data.paired) {
        for (const [key, label] of [['inch', this.config.inchLabel], ['cm', this.config.cmLabel]]) {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.unit = key;
          button.textContent = label;
          button.addEventListener('click', () => { unit = key; paint(); });
          tabs.append(button);
        }
        panel.append(tabs);
      }
      panel.append(wrap);
      paint();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-sticky-purchase"]) return;
  try {
    
  Promise.all([import('@shopify/events'), import('@theme/events')]).then(([{ StandardEvents }, { ThemeEvents }]) => {

  class NsStickyPurchase extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      this.pending = false;
      this.busy = '';
      this.added = false;
      this.generation = 0;
      this.operation = 0;
      this.walletProductId = this.dataset.productId;
      this.walletReady = false;
      this.frame = 0;
      this.visibilityFrame = 0;
      this.panel = this.querySelector('[data-nsp-panel]');
      this.addButton = this.querySelector('[data-nsp-add]');
      this.addText = this.querySelector('[data-nsp-add-text]');
      this.buyButton = this.querySelector('[data-nsp-buy]');
      this.wallet = this.querySelector('[data-nsp-wallet]');
      this.walletForm = this.wallet.querySelector('form');
      this.feedback = this.querySelector('[data-nsp-feedback]');
      this.options = this.querySelector('[data-nsp-options]');
      const start = () => {
        customElements.whenDefined('product-form-component').then(() => {
          if (this.isConnected && !this.abortController.signal.aborted) this.mount();
        });
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true, signal: this.abortController.signal });
      } else {
        start();
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.mainObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.visibilityFrame);
      clearTimeout(this.addedTimer);
      this.abortController = null;
      this.panel.hidden = true;
      this.removeAttribute('data-ready');
      this.observedSection = null;
      this.observedAnchor = null;
      if (!document.querySelector('ns-sticky-purchase[data-ready="true"]')) {
        document.body.classList.remove('ns-sticky-purchase-ready');
      }
    }

    findMain() {
      const component = document.querySelector('#MainContent .product-information product-form-component');
      const form = component?.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return null;
      return {
        component,
        form,
        section: component.closest('.shopify-section'),
        button: component.querySelector('[ref="addToCartButton"]'),
      };
    }

    mount() {
      if (this.dataset.ready === 'true' || !this.findMain()) return;
      const { signal } = this.abortController;
      this.addButton.addEventListener('click', () => this.addToCart(), { signal });
      this.buyButton.addEventListener('click', () => this.buyNow(), { signal });
      document.addEventListener(StandardEvents.productSelect, (event) => this.selectVariant(event), { signal });
      document.addEventListener(StandardEvents.cartLinesUpdate, (event) => this.cartUpdated(event), { signal });
      document.addEventListener(StandardEvents.cartError, (event) => this.cartFailed(event), { signal });
      document.addEventListener(ThemeEvents.quantitySelectorUpdate, (event) => {
        if (!event.detail?.cartLine) this.scheduleSync();
      }, { signal });
      for (const name of ['input', 'change']) {
        document.addEventListener(name, (event) => {
          const main = this.findMain();
          if (main?.section?.contains(event.target) || event.target?.form === main?.form) this.scheduleSync();
        }, { signal });
      }
      this.wallet.addEventListener('click', (event) => {
        if (!this.snapshot(true)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true, signal });
      this.wallet.addEventListener('pointerdown', () => this.syncWallet(), { capture: true, signal });
      this.wallet.addEventListener('focusin', () => this.syncWallet(), { capture: true, signal });
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted) return;
        this.busy = '';
        this.pending = false;
        this.added = false;
        this.sync();
      }, { signal });
      window.addEventListener('resize', () => this.scheduleSync(), { passive: true, signal });
      window.addEventListener('scroll', () => this.scheduleVisibility(), { passive: true, signal });
      document.addEventListener('scroll', () => this.scheduleVisibility(), { capture: true, passive: true, signal });
      document.addEventListener('focusin', () => this.scheduleSync(), { signal });
      document.addEventListener('focusout', () => this.scheduleSync(), { signal });
      window.visualViewport?.addEventListener('resize', () => this.scheduleSync(), { passive: true, signal });
      this.mainObserver = new MutationObserver(() => this.scheduleSync());
      this.intersectionObserver = new IntersectionObserver(() => this.updateVisibility());
      this.bindMain();
      const host = this.wallet.querySelector('shopify-accelerated-checkout');
      if (host) {
        customElements.whenDefined('shopify-accelerated-checkout').then(() => {
          if (!this.isConnected || signal.aborted) return;
          this.walletReady = true;
          this.updateButtons();
        });
      }
      this.dataset.ready = 'true';
      document.body.classList.add('ns-sticky-purchase-ready');
      this.sync();
    }

    bindMain() {
      const main = this.findMain();
      if (!main) return;
      if (this.observedSection !== main.section) {
        this.mainObserver.disconnect();
        this.observedSection = main.section;
        this.mainObserver.observe(main.section, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['disabled', 'class', 'value', 'data-product-id', 'data-current-variant-id', 'data-variant-available'],
        });
      }
      const anchor = main.component.closest('.buy-buttons-block') || main.component;
      if (this.observedAnchor !== anchor) {
        this.intersectionObserver.disconnect();
        this.observedAnchor = anchor;
        this.intersectionObserver.observe(anchor);
        this.footers = Array.from(document.querySelectorAll('.ns-home-footer, footer')).filter((footer) => {
          const box = footer.getBoundingClientRect();
          return box.width > 0 && box.height > 0;
        });
        for (const footer of this.footers) this.intersectionObserver.observe(footer);
      }
    }

    scheduleSync() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        if (this.isConnected) this.sync();
      });
    }

    sync() {
      this.bindMain();
      const main = this.findMain();
      if (!main) {
        this.panel.hidden = true;
        this.removeAttribute('data-ready');
        document.body.classList.remove('ns-sticky-purchase-ready');
        return;
      }
      this.dataset.ready = 'true';
      document.body.classList.add('ns-sticky-purchase-ready');
      const id = main.form.querySelector('[name="id"]')?.value || '';
      const picker = main.section.querySelector('variant-picker[data-template-product-match="true"]') || main.section.querySelector('variant-picker');
      let variant = null;
      const json = picker?.querySelector('script[type="application/json"]')?.textContent;
      if (json) {
        try { variant = JSON.parse(json); } catch { variant = null; }
      }
      const native = main.section.querySelector('sticky-add-to-cart');
      this.consistent = picker ? Boolean(variant?.id) && String(variant.id) === id : !native || native.dataset.currentVariantId === id;
      this.variantId = id;
      this.available = Boolean(id) && (variant ? variant.available !== false : native ? native.dataset.variantAvailable === 'true' : !main.button?.disabled);
      const title = picker?.dataset.productTitle || native?.querySelector('.sticky-add-to-cart__title')?.textContent?.trim();
      const titleLink = this.querySelector('[data-nsp-title]');
      if (title) {
        titleLink.textContent = title;
        titleLink.title = title;
      }
      const url = new URL(main.component.dataset.productUrl || titleLink.getAttribute('href'), window.location.origin);
      if (id) url.searchParams.set('variant', id);
      titleLink.href = url.href;
      const imageLink = this.querySelector('[data-nsp-image-link]');
      imageLink.href = url.href;
      imageLink.setAttribute('aria-label', titleLink.textContent.trim());
      const sourceImage = variant?.featured_image?.src || variant?.featured_media?.preview_image?.src || native?.querySelector('img')?.getAttribute('src');
      if (sourceImage) {
        const imageUrl = new URL(sourceImage, window.location.origin);
        imageUrl.searchParams.set('width', '160');
        const image = imageLink.querySelector('img');
        if (image.getAttribute('src') !== imageUrl.href) {
          image.removeAttribute('srcset');
          image.src = imageUrl.href;
        }
        image.alt = variant?.featured_image?.alt || titleLink.textContent.trim();
        image.hidden = false;
        imageLink.hidden = false;
      }
      if (picker) {
        const options = [];
        for (const field of picker.querySelectorAll('fieldset')) {
          const selected = field.querySelector('input:checked') || field.querySelector('select option:checked');
          if (!selected) continue;
          const legend = field.querySelector('legend');
          const name = selected.dataset.optionName || legend?.firstChild?.textContent?.trim() || '';
          const span = document.createElement('span');
          const label = document.createElement('span');
          label.className = 'nsp-option-name';
          label.textContent = name ? `${name}: ` : '';
          span.append(label, document.createTextNode(selected.value));
          options.push(span);
        }
        this.options.replaceChildren(...options);
        this.options.hidden = options.length === 0;
      }
      const price = main.section.querySelector('.product-details product-price [ref="priceContainer"]') || native?.querySelector('.sticky-add-to-cart__price');
      const priceTarget = this.querySelector('[data-nsp-price]');
      if (price) {
        const prices = price.querySelectorAll('.price, .compare-at-price');
        const signature = Array.from(prices, (item) => `${item.className}:${item.textContent}`).join('|');
        if (signature !== this.priceSignature && prices.length) {
          priceTarget.replaceChildren(...Array.from(prices, (item) => item.cloneNode(true)));
          this.priceSignature = signature;
        }
      }
      this.quantity = Number(new FormData(main.form).get('quantity') || main.component.dataset.quantityDefault || 1);
      this.syncWallet();
      const nativeError = main.component.querySelector('[ref="addToCartTextError"]');
      if (this.busy === 'add' && !this.nativeAcknowledged && nativeError && !nativeError.classList.contains('hidden') && nativeError.textContent.trim()) {
        this.finishAdd(false, nativeError.textContent.trim());
      }
      this.updateButtons();
      this.updateVisibility();
    }

    async selectVariant(event) {
      const target = event.target;
      const main = this.findMain();
      if (!(target instanceof Element) || !main?.section?.contains(target) || target.closest('product-card, dialog')) return;
      if (!event.promise) return;
      const generation = ++this.generation;
      this.pending = true;
      clearTimeout(this.addedTimer);
      this.added = false;
      this.showFeedback('');
      this.updateButtons();
      try {
        await event.promise;
        await new Promise(requestAnimationFrame);
        if (generation !== this.generation || !this.isConnected) return;
        this.pending = false;
        this.sync();
      } catch (error) {
        if (generation !== this.generation || !this.isConnected) return;
        this.pending = true;
        if (error?.name !== 'AbortError') this.showFeedback(this.dataset.errorLabel);
        this.updateButtons();
      }
    }

    syncWallet() {
      const main = this.findMain();
      if (!main || !this.walletForm) return;
      const source = new FormData(main.form);
      const entries = Array.from(source.entries()).filter(([name]) => name === 'selling_plan' || name.startsWith('properties['));
      this.walletHasFile = entries.some(([, value]) => typeof value !== 'string' && value.size > 0);
      const id = source.get('id') || '';
      const quantity = source.get('quantity') || main.component.dataset.quantityDefault || '1';
      const signature = JSON.stringify([id, quantity, entries.map(([name, value]) => [name, typeof value === 'string' ? value : value.name])]);
      if (signature === this.walletSignature) return;
      this.walletSignature = signature;
      const idInput = this.walletForm.querySelector('[data-nsp-variant]');
      const quantityInput = this.walletForm.querySelector('[data-nsp-quantity]');
      idInput.value = String(id);
      quantityInput.value = String(quantity);
      const properties = this.walletForm.querySelector('[data-nsp-properties]');
      properties.replaceChildren();
      for (const [name, value] of entries) {
        if (typeof value !== 'string') continue;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        properties.append(input);
      }
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateButtons() {
      const main = this.findMain();
      const locked = this.pending || Boolean(this.busy) || !this.consistent || !this.available || !main?.button || main.button.disabled;
      this.addButton.disabled = locked;
      this.buyButton.disabled = locked;
      this.addButton.setAttribute('aria-busy', this.busy === 'add' ? 'true' : 'false');
      this.buyButton.setAttribute('aria-busy', this.busy === 'buy' ? 'true' : 'false');
      const label = !this.variantId ? this.dataset.unavailableLabel : !this.available ? this.dataset.soldLabel : this.busy ? this.dataset.addingLabel : this.added ? this.dataset.addedLabel : this.dataset.addLabel;
      this.addText.textContent = `${label}${!this.busy && this.available && this.quantity > 1 ? ` (${this.quantity})` : ''}`;
      this.buyButton.textContent = !this.available ? this.addText.textContent : this.busy === 'buy' ? this.dataset.addingLabel : this.dataset.buyLabel;
      const useWallet = this.dataset.mobileWallets === 'true' && this.walletReady && this.available && !this.walletHasFile && main?.component.dataset.productId === this.walletProductId;
      this.querySelector('[data-nsp-quick]').dataset.mode = useWallet ? 'wallet' : 'buy';
      this.wallet.hidden = !useWallet;
      this.wallet.inert = locked;
      this.wallet.setAttribute('aria-disabled', locked ? 'true' : 'false');
      const idInput = this.walletForm.querySelector('[data-nsp-variant]');
      if (idInput.disabled !== Boolean(locked)) {
        idInput.disabled = Boolean(locked);
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    scheduleVisibility() {
      if (this.visibilityFrame) return;
      this.visibilityFrame = requestAnimationFrame(() => {
        this.visibilityFrame = 0;
        if (this.isConnected) this.updateVisibility();
      });
    }

    updateVisibility() {
      const anchor = this.observedAnchor;
      if (!anchor?.isConnected) {
        this.panel.hidden = true;
        return;
      }
      const container = anchor.closest('.page-wrapper');
      const containerBox = container?.getBoundingClientRect();
      const clips = container && /auto|scroll|hidden|clip/.test(getComputedStyle(container).overflowY);
      const viewportTop = clips ? Math.max(0, containerBox.top) : 0;
      const viewportBottom = clips ? Math.min(window.innerHeight, containerBox.bottom) : window.innerHeight;
      const desktop = window.innerWidth >= 750;
      const distance = Number(this.dataset.desktopScroll) || 320;
      const passed = desktop
        ? this.observedSection.getBoundingClientRect().top <= viewportTop - distance
        : anchor.getBoundingClientRect().bottom <= viewportTop;
      const footerVisible = (this.footers || []).some((footer) => {
        const box = footer.getBoundingClientRect();
        return box.width > 0 && box.height > 0 && box.top < viewportBottom && box.bottom > viewportTop;
      });
      const active = document.activeElement;
      const editing = active?.matches('input:not([type="hidden"]), textarea, [contenteditable="true"]');
      const keyboard = editing && window.visualViewport && window.visualViewport.height < window.innerHeight * 0.75;
      this.panel.hidden = !passed || footerVisible || Boolean(keyboard);
    }

    snapshot(report) {
      if (this.pending || this.busy) return null;
      this.sync();
      const main = this.findMain();
      if (!main || !this.consistent || !this.available || main.button?.disabled) return null;
      if (!main.form.checkValidity()) {
        if (report) main.form.reportValidity();
        return null;
      }
      const data = new FormData(main.form);
      const id = String(data.get('id') || '');
      const quantity = Number(data.get('quantity') || main.component.dataset.quantityDefault || 1);
      if (!/^\d+$/.test(id) || id !== this.variantId || !Number.isSafeInteger(quantity) || quantity < 1) {
        if (report) this.showFeedback(this.dataset.errorLabel);
        return null;
      }
      const selector = main.component.querySelector('quantity-selector-component');
      const validation = selector?.canAddToCart?.();
      if (validation && !validation.canAdd) {
        if (report) this.showFeedback(this.dataset.errorLabel);
        return null;
      }
      data.set('id', id);
      data.set('quantity', String(quantity));
      data.delete('sections');
      data.delete('sections_url');
      data.delete('return_to');
      return { main, data };
    }

    addToCart() {
      const snapshot = this.snapshot(true);
      if (!snapshot) return;
      this.showFeedback('');
      this.added = false;
      this.busy = 'add';
      this.nativeAcknowledged = false;
      this.addedVariantId = String(snapshot.data.get('id'));
      this.operation += 1;
      this.updateButtons();
      try {
        if (typeof snapshot.main.component.handleSubmit === 'function') {
          snapshot.main.component.handleSubmit(new SubmitEvent('submit', {
            bubbles: true,
            cancelable: true,
            submitter: snapshot.main.button,
          }));
        } else {
          snapshot.main.form.requestSubmit(snapshot.main.button);
        }
      } catch (error) {
        this.finishAdd(false, error?.message || this.dataset.errorLabel);
      }
      this.scheduleSync();
    }

    cartUpdated(event) {
      const main = this.findMain();
      if (this.busy !== 'add' || event.target !== main?.component || !event.promise) return;
      this.nativeAcknowledged = true;
      const operation = this.operation;
      event.promise.then(({ detail }) => {
        if (!this.isConnected || operation !== this.operation) return;
        this.finishAdd(!detail?.didError, detail?.didError ? this.feedback.textContent || this.dataset.errorLabel : '');
      }).catch(() => {
        if (this.isConnected && operation === this.operation) this.finishAdd(false, this.feedback.textContent || this.dataset.errorLabel);
      });
    }

    cartFailed(event) {
      const main = this.findMain();
      if (this.busy !== 'add' || event.target !== main?.component) return;
      const message = event.detail?.description || event.detail?.message || event.error || this.dataset.errorLabel;
      this.showFeedback(typeof message === 'string' ? message : this.dataset.errorLabel);
      if (!this.nativeAcknowledged) this.finishAdd(false, this.feedback.textContent);
    }

    finishAdd(success, message) {
      this.busy = '';
      this.added = success && this.variantId === this.addedVariantId;
      if (message) this.showFeedback(message);
      this.sync();
      clearTimeout(this.addedTimer);
      if (success) {
        this.addedTimer = setTimeout(() => {
          if (!this.isConnected) return;
          this.added = false;
          this.updateButtons();
        }, 1400);
      }
    }

    async buyNow() {
      const snapshot = this.snapshot(true);
      if (!snapshot) return;
      this.showFeedback('');
      this.busy = 'buy';
      this.updateButtons();
      try {
        const response = await fetch(`${this.dataset.rootUrl}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body: snapshot.data,
        });
        const result = await response.json();
        if (!response.ok || Number(result.status) >= 400) {
          const message = result.description || result.message || this.dataset.errorLabel;
          throw new Error(typeof message === 'string' ? message : this.dataset.errorLabel);
        }
        if (this.isConnected) this.goToCheckout();
      } catch (error) {
        if (!this.isConnected) return;
        this.busy = '';
        this.showFeedback(error?.message || this.dataset.errorLabel);
        this.sync();
      }
    }

    goToCheckout() {
      window.location.assign(this.dataset.checkoutUrl);
    }

    showFeedback(message) {
      this.feedback.textContent = message;
      this.feedback.hidden = !message;
    }
  }

  if (!customElements.get('ns-sticky-purchase')) {
    customElements.define('ns-sticky-purchase', NsStickyPurchase);
  }
  }).catch(() => {});

  } catch(e) { console.error(e); }
})();
})();
